import React from "react";

export const PageHeaderSkeleton: React.FC = () => {
  return (
    <div className="ob-page-header">
      <div className="ob-page-header-content">
        <h1 className="ob-page-title">
          <span className="ob-skeleton ob-skeleton-text" style={{ width: "200px", height: "32px", display: "inline-block" }} />
        </h1>
        <div className="ob-page-subtitle-row">
          <p className="ob-page-subtitle">
            <span className="ob-skeleton ob-skeleton-text" style={{ width: "400px", height: "14px", display: "inline-block" }} />
          </p>
        </div>
      </div>
      <div className="ob-page-header-actions">
        <p className="ob-items-count">
          <span className="ob-skeleton ob-skeleton-text" style={{ width: "80px", height: "16px", display: "inline-block" }} />
        </p>
      </div>
    </div>
  );
};
